<div class="flex gap-2 justify-end">
  <app-pan-button
    panRole
    [roles]="['admin']"
    color="primary"
    icon="add"
    (click)="params.addCallback(params.data)"
    matTooltip="Add Location To Group"
  ></app-pan-button>
</div>
